var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { hero: true, mobile: _vm.isMobile(_vm.$mq) } }, [
    _c("div", { staticClass: "container" }, [
      _c("header", [
        _c(
          "h1",
          { class: { "is-mathcounts": _vm.isMathcounts } },
          [_vm._t("header")],
          2
        ),
        _vm._v(" "),
        _c("h2", [_vm._t("intro-text")], 2),
        _vm._v(" "),
        _c(
          "a",
          {
            directives: [
              {
                name: "track",
                rawName: "v-track:click",
                value: _vm.ctaAxParams,
                expression: "ctaAxParams",
                arg: "click"
              }
            ],
            staticClass: "btn",
            attrs: { href: _vm.getStartedHref },
            on: { click: _vm.getStartedClickHandler }
          },
          [_vm._v("\n        " + _vm._s(_vm.ctaButtonText) + "\n      ")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "video" }, [
        _c(
          "video",
          {
            attrs: {
              preload: "auto",
              autoplay: "",
              muted: "",
              playsinline: "",
              loop: ""
            },
            domProps: { muted: true }
          },
          [_c("source", { attrs: { src: _vm.videoUrl, type: "video/mp4" } })]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "b-topics container" },
      _vm._l(_vm.topics, function(topic) {
        return _c(
          _vm.isBelowFold ? "a" : "div",
          {
            key: topic.url,
            tag: "component",
            staticClass: "topic",
            attrs: { href: _vm.isBelowFold ? topic.url : null }
          },
          [
            _c("img", {
              attrs: {
                src: topic.image,
                alt: topic.name,
                width: "132",
                height: "132",
                loading: "lazy"
              }
            }),
            _vm._v(" "),
            _c("h3", [_vm._v(_vm._s(topic.name))])
          ]
        )
      }),
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "why-join-brilliant" }, [
      _c("div", { staticClass: "content-wrap" }, [
        _c("h3", [_vm._v("Join over 10 million people learning on Brilliant")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "list" },
          [
            _c("PublishersList", {
              staticClass: "publishers social-proof",
              attrs: { reduced: true }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "sep" }),
            _vm._v(" "),
            _c("AppRating", {
              staticClass: "social-proof",
              attrs: { landing: true, mobile: _vm.isMobile(_vm.$mq) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "sep" }),
            _vm._v(" "),
            _c("TrustpilotRating", {
              staticClass: "landing social-proof trustpilot-frame"
            }),
            _vm._v(" "),
            _c("div", { staticClass: "sep" }),
            _vm._v(" "),
            _vm._m(0)
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-awards" }, [
      _c("img", {
        attrs: {
          src:
            "/site_media/version-5aebc1c6e2/images/homepage/app-of-the-day.png",
          alt: "App of the day award",
          loading: "lazy",
          width: "127",
          height: "58"
        }
      }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: "/site_media/version-9ae1f4133c/images/homepage/best-app.png",
          alt: "Best-app award",
          loading: "lazy",
          width: "131",
          height: "58"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }